
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { postData } from "../../../../../ApiServices/ApiService";
import { logFrontendException } from "../../../../../Utils/Exception";
import { ORG_CONFIGURATION_CONFIG_CENTER } from "../../../../../ApiServices/BaseURL";
import { validateMobileNumber } from "../../../../../Utils/Validation";
import { useTheme } from "../../../../../GlobalContext/GlobalContext";

const WhatsAppConfigurationController = (data, loading, error, onRefresh) => {
    const [accessToken, setAccessToken] = useState('');
    const [webhookUrl, setWebhookUrl] = useState('');
    const [whatsappId, setWhatsappId] = useState('');
    const [whatsappMobileNo, setWhatsappMobileNo] = useState('');
    const [countryCode, setCountryCode] = useState('+91');

    const [saveLoading, setSaveLoading] = useState(false);
    const [saveError, setSaveError] = useState('');
    const [success, setSuccess] = useState('');

    const [accessTokenError, setAccessTokenError] = useState('');
    const [urlError, setUrlError] = useState('');
    const [mobileNoError, setMobileNoError] = useState('');

    const navigator = useNavigate();

    const { setIsLoginPopup } = useTheme();

    const pageName = "WhatsAppConfigurationController";

    useEffect(() => {
        if (data) {
            setAccessToken(data?.access_token || '');
            setWebhookUrl(data?.whatsapp_webhook_url || '');
            setWhatsappId(data?.whatsapp_id || '');
            setWhatsappMobileNo(data?.whatsapp_mobileno || '');
        }
        setSaveError(error);
        setSaveLoading(loading);
    }, [data, error, loading]);

    const saveWhatsAppConfig = async () => {
        setSaveLoading(true);
        setSaveError('');
        setSuccess('');
        setAccessTokenError('');
        setUrlError('');
        setMobileNoError('');

        const storedUser = JSON.parse(localStorage.getItem("_userInfo_"));

        // Validate required fields
        if (!accessToken.trim()) {
            setAccessTokenError("Access Token is required.");
            setSaveLoading(false);
            return;
        }
        if (accessToken.length < 50) {
            setAccessTokenError("Access Token appears to be invalid (too short).");
            setSaveLoading(false);
            return;
        }
        if (!/^[A-Za-z0-9-_\.]+$/.test(accessToken)) {
            setAccessTokenError("Access Token contains invalid characters.");
            setSaveLoading(false);
            return;
        }
        if (!webhookUrl.trim()) {
            setUrlError("Webhook URL is required.");
            setSaveLoading(false);
            return;
        }
        if (whatsappMobileNo) {
            if (!validateMobileNumber(whatsappMobileNo)) {
                setMobileNoError("Mobile number must be 10 digits.");
                setSaveLoading(false);
                return
            }
        }
        try {
            const url = new URL(webhookUrl);
            if (url.protocol !== "https:") {
                setUrlError("Webhook URL must use https://");
                setSaveLoading(false);
                return;
            }
        } catch {
            setUrlError("Invalid Webhook URL format.");
            setSaveLoading(false);
            return;
        }

        const payload = {
            op: 'whatsapp',
            action_type: data ? "update_whatsapp_config" : "add_whatsapp_config",
            emp_id_auth: storedUser?.emp_id,
            access_token: accessToken,
            whatsapp_webhook_url: webhookUrl,
            whatsapp_id: whatsappId,
            whatsapp_mobileno: whatsappMobileNo,
            mobile_code: countryCode,
        };

        console.log("peyload", payload)

        try {
            const response = await postData(ORG_CONFIGURATION_CONFIG_CENTER, payload);
            const responseData = await response.json();

            if (response?.status === 200) {
                if (responseData?.statusCode === 200) {
                    if (responseData?.message?.toLowerCase() === "success") {
                        setSuccess(responseData?.info || "WhatsApp configuration updated successfully.");
                        setTimeout(() => {
                            onRefresh();
                            setSuccess('');
                        }, 3000);
                    } else {
                        setSaveError(responseData?.info || "Failed to add/update WhatsApp configuration.");
                        logFrontendException(storedUser?.emp_id, pageName, "saveWhatsAppConfig", responseData?.info);
                    }
                } else {
                    setSaveError(responseData?.info || "Unable to add/update WhatsApp configuration.Please try again.");
                    logFrontendException(storedUser?.emp_id, pageName, "saveWhatsAppConfig", responseData);
                }
            } else if (response?.status === 400 || response?.status === 401 || response?.status === 403) {
                setSaveError('Unauthorized access. Your session may have expired. Please log in again.');
                setIsLoginPopup(true)
                logFrontendException(storedUser?.emp_id, pageName, 'saveWhatsAppConfig-Unauthorized', response || '');
            } else {
                setSaveError("Failed to add/update WhatsApp configuration.");
                logFrontendException(storedUser?.emp_id, pageName, "saveWhatsAppConfig", response);
            }
        } catch (error) {
            setSaveError("Failed to add/update WhatsApp configuration.Please Check your internet connection and try again.");
            logFrontendException(storedUser?.emp_id, pageName, "saveWhatsAppConfig-catch", error);
        } finally {
            setSaveLoading(false);
        }
    };

    const handleCancel = () => {
        navigator('/dashboard');
    }

    return {
        accessToken,
        setAccessToken,
        webhookUrl,
        setWebhookUrl,
        whatsappId,
        setWhatsappId,
        whatsappMobileNo,
        setWhatsappMobileNo,
        saveLoading,
        saveError,
        success,
        saveWhatsAppConfig,
        urlError,
        setUrlError,
        accessTokenError,
        setAccessTokenError,
        handleCancel,
        countryCode,
        setCountryCode,
        mobileNoError,
        setMobileNoError,
    }
}
export default WhatsAppConfigurationController;